import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { TreemapService } from './treemap.service';
import { AlertaService } from '../alerta/alerta.service';
import { LoadingService } from '../loading/loading.service';
import { CommonModule } from '@angular/common';
import { getChartGoogle } from '../chart-google';
import { firstValueFrom, Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState } from '../app.state';
import { selectAcuerdo } from '../states/acuerdo/selector';
import { selectEntrada } from '../states/entrada/selector';
import { selectUsuario } from '../states/usuario/selector';
import { iEntrada, iAcuerdo } from '../entrada/entrada.interface';
import { iUsuario } from '../usuario/usuario.interface';


@Component({
  selector: 'app-treemap',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, CommonModule],
  templateUrl: './treemap.component.html',
  styleUrl: './treemap.component.css'
})
export class TreemapComponent {
  private active = inject(ActivatedRoute);
  private router = inject(Router);
  private store: Store<AppState> = inject(Store);
  private loadingService = inject(LoadingService);
  private alertaService = inject(AlertaService);
  private treemapService = inject(TreemapService);
  private subscriptions = new Subscription();
  
  public readonly stateEntrada: any = this.store.pipe(select(selectEntrada));
  public readonly stateUsuario: any = this.store.pipe(select(selectUsuario));
  public readonly stateAcuerdo: any = this.store.pipe(select(selectAcuerdo));

  public idEntrada: string = this.active.snapshot.params['id'];
  public idTema: string = this.active.snapshot.params['tema'];
  public oEntrada: iEntrada;
  public oUsuario: iUsuario;
  public oAcuerdo: iAcuerdo;
  public oTreeMap: any; 

  public cg: any;
  public dataChart: any;
  public chart: any;

  constructor () {
    this.oEntrada = structuredClone(this.stateEntrada.state().entrada);
    this.oUsuario = structuredClone(this.stateUsuario.state().usuario);
    this.oAcuerdo = structuredClone(this.stateAcuerdo.state().acuerdo);
  }

  async ngOnInit () {
    this.cg = getChartGoogle();
    this.cg.charts.load('current', {'packages': ['corechart', 'orgchart', 'table']});
  }

  
  ngOnDestroy (): void {
    this.subscriptions.unsubscribe();
  }

  async showChart () {
    this.alertaService.treeMap();

    const data: any = await this.getDataTreeMap();
    if(data.tree) {
      this.oTreeMap = data.tree;
    } else {
      this.loadingService.hide();
      this.alertaService.open('Error', 'Ups problemas al cargar los datos');
      return;
    }

    this.dataChart = new this.cg.visualization.DataTable();
    this.dataChart.addColumn('string', 'Name');
    this.dataChart.addColumn('string', 'Manager');
    this.dataChart.addRows(this.oTreeMap);

    this.validateHtml();
  }

  async getDataTreeMap () {
    const result: any = await firstValueFrom(this.treemapService.obtenerTreeMap(this.idEntrada));
    if(result.tree)
      this.changeURL(result.tree);

    return result;
  }

  changeURL(tree: any): any {
    for(const property in tree) {
      let item = tree[property];

      if(Array.isArray(item)) {
        this.changeURL(item);
      } else if(typeof item ==  'object') {
        this.changeURL(item);
      } else if(typeof item ==  'string') {
        if(item.includes("#entrada/corporativo/")) {
          tree[property] = item.replace('#entrada/corporativo/', 'entrada/');
        } else {
          tree[property] = item.replace('#entrada/', 'entrada/');
        }
      }
    }
  }

  validateHtml () {
    if(document.getElementById('chart_div') == undefined) {
      setTimeout(() => {
        this.validateHtml();
      }, 1000);
    } else {
      this.paintChart();
    }
  }

  paintChart () {
    this.chart = new this.cg.visualization.OrgChart(document.getElementById('chart_div'));
    this.chart.draw(this.dataChart, {allowHtml:true, size: 'small'});
  }

  mostrarEliminar () {
    const mostrar = (
      this.oUsuario.uid == this.oEntrada.analista || 
      this.oUsuario.uid == this.oEntrada.supervisor || 
      this.oUsuario.uid == this.oEntrada.coordinador
    );

    return mostrar
  }

  mostrarPregunta () {
    if(this.oAcuerdo.id_tipo_forma == 2 && this.oAcuerdo.numeroEntradasTema == 1) {
      this.alertaService.open('Importante', 'No es posible eliminar esta entrada debido a que es la única entrada relacionada a un tema de despacho. Si requiere eliminarla, asigne nuevas entradas al despacho, o bien, seleccione la acción \'Quitar tema\' desde la tabla de despacho para eliminar el tema. Posteriormente, intente nuevamente la eliminación de la entrada.');
      return;
    }

    const dialogRef = this.alertaService.confirm({
      title: '¿Esta seguro de eliminar esta entrada?', 
      description: 'Esta acción no se podra deshacer.',
      aceptar: 'BORRAR'
    });
    dialogRef.afterClosed().subscribe((result:any) => {
      if(result) {
        this.eliminarEntrada();
      }
    });
  }

  eliminarEntrada () {
    this.loadingService.show();

    this.subscriptions.add(
      this.treemapService.eliminarEntrada(this.idEntrada).subscribe({
        next: (result: any) => {
          if(result.error) {
            this.alertaService.open('Error 010', result.msg);
          } else {
            this.router.navigate(['/agenda']);
          }
          this.loadingService.hide();
        },
        error: (error: any) => {
          this.alertaService.open('Error 011', error.toString());
          this.loadingService.hide();
        },
        complete: () => this.loadingService.hide()
      })
    );
  }
}
